export default function ({ store, app }) {
    const globalSettings = store.state.global.globalSettings || {};
    const items = globalSettings?.styles?.additional_js_items || [];

    items.forEach((item, index) => {
        if (!item || !item.script) return;

        const isScript = item.script_type === 'script';
        const isNoScript = item.script_type === 'noscript';
        const isBody = item.location === 'body';

        if (process.client && isBody) {
            const tag = document.createElement(isNoScript ? 'noscript' : 'script');
            if (isScript) {
                tag.type = 'text/javascript';
            }
            tag.innerHTML = item.script;
            tag.setAttribute('data-from', `custom-body-${index}`);
            document.body.appendChild(tag);
        }
    });
}
